import {Component, input} from '@angular/core';

@Component({
  selector: 'avatar-icon',
  imports: [],
  templateUrl: './avatar-icon.component.html',
  styleUrl: './avatar-icon.component.css',
})
export class AvatarIconComponent {
  user = input.required<any>();
}
